'use client';

import { TracerxBrowserResolver } from 'tracerx/browser';

const tracerxApiKey = import.meta.env.VITE_HYPERDX_API_KEY ?? '';
const tracerxUrl = import.meta.env.VITE_HYPERDX_URL ?? '';
const tracerxService = import.meta.env.VITE_HYPERDX_SERVICE ?? '';
const apiBaseUrl = import.meta.env.VITE_API_BASE_URL ?? '';
const tracePropagationTargets = apiBaseUrl ? [apiBaseUrl] : [];

const isTracerxActive =
  import.meta.env.VITE_TRACERX_ACTIVE === 'true' && Boolean(tracerxApiKey) && Boolean(tracerxUrl);

export function TracerxBrowserInstrumentation() {
  return (
    <TracerxBrowserResolver
      isActive={isTracerxActive}
      apiKey={tracerxApiKey}
      service={tracerxService}
      url={tracerxUrl}
      consoleCapture
      advancedNetworkCapture={true}
      tracePropagationTargets={tracePropagationTargets}
    />
  );
}
